module.exports = __webpack_public_path__ + "img/obama8ML.5395baf3.jpg";